import * as yup from 'yup';

const usernamePattern = /^[a-z0-9]+$/;
const emailSchema = yup.string().email();

export const loginSchema = yup.object().shape({
  username: yup
    .string()
    .transform((value) => (value ? value.trim() : value))
    .required()
    .test({
      name: 'username_or_email',
      message: 'username_or_email',
      test: (value) => {
        if (!value) return true;
        return usernamePattern.test(value) || emailSchema.isValidSync(value);
      },
    }),
  password: yup.string().required(),
});

export const defaultValuesLoginForm = {
  username: '',
  password: '',
};
